import { render, staticRenderFns } from "./NotificationRevision.vue?vue&type=template&id=53d4e2a3"
import script from "./NotificationRevision.vue?vue&type=script&lang=js"
export * from "./NotificationRevision.vue?vue&type=script&lang=js"
import style0 from "./NotificationRevision.vue?vue&type=style&index=0&id=53d4e2a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports